import { createBrowserRouter } from 'react-router';

import ErrorRoutes from './ErrorRoutes';
import StartRoutes from './StartRoutes';
//
export const AppRouter = createBrowserRouter([StartRoutes, ErrorRoutes]);
